import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=422d6079&scoped=true"
import script from "./Cabecalho.vue?vue&type=script&lang=js"
export * from "./Cabecalho.vue?vue&type=script&lang=js"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=422d6079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d6079",
  null
  
)

export default component.exports